import React, { FC, PropsWithChildren } from 'react';

interface TrashCanIconProps {
  className?: string;
  onClick: () => void;
  height: string;
  width: string;
}

export const TrashCanIcon: FC<PropsWithChildren<TrashCanIconProps>> = (
  {
    className,
    onClick,
    height,
    width,
  },
) => (
  <button
    type="button"
    onClick={onClick}
  >
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.96578 4.03367C4.97033 3.83122 6.97512 3.72998 8.98005 3.72998C12.3454 3.72998 15.7201 3.90127 19.074 4.23364C19.4862 4.27448 19.7872 4.64175 19.7464 5.05394C19.7055 5.46614 19.3383 5.76717 18.9261 5.72632C15.62 5.39869 12.2947 5.22998 8.98005 5.22998C7.02535 5.22998 5.07051 5.3287 3.11543 5.52618L3.11323 5.5264L1.07323 5.7264C0.660996 5.76682 0.294048 5.4654 0.253633 5.05316C0.213218 4.64092 0.514639 4.27397 0.926876 4.23356L2.96578 4.03367Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.45958 2.78456L7.23964 4.09421C7.17104 4.50271 6.78427 4.77824 6.37578 4.70964C5.96729 4.64104 5.69175 4.25428 5.76035 3.84578L5.98035 2.53579C5.9842 2.51297 5.98815 2.48908 5.99216 2.46487C6.06102 2.04899 6.16203 1.43887 6.56873 0.977691C7.04279 0.440117 7.76609 0.25 8.69 0.25H11.31C12.2451 0.25 12.9677 0.455399 13.439 0.998446C13.8462 1.46776 13.9447 2.08006 14.0105 2.48891C14.0137 2.5088 14.0168 2.52822 14.0199 2.54711L14.2395 3.84486C14.3086 4.25326 14.0335 4.64037 13.6251 4.70949C13.2167 4.7786 12.8296 4.50355 12.7605 4.09514L12.5398 2.79069C12.4561 2.27767 12.4032 2.09352 12.306 1.98155C12.2523 1.9196 12.0649 1.75 11.31 1.75H8.69C7.9239 1.75 7.7422 1.91488 7.69376 1.96981C7.60165 2.07427 7.54966 2.24976 7.45958 2.78456Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8984 7.3916C17.3117 7.41828 17.6252 7.775 17.5985 8.18835L16.9482 18.2625L16.9469 18.2815C16.9205 18.6577 16.8916 19.0714 16.814 19.4564C16.7336 19.8556 16.592 20.2768 16.3048 20.6506C15.7037 21.4333 14.6806 21.75 13.2101 21.75H6.79005C5.31949 21.75 4.29642 21.4333 3.69525 20.6506C3.40815 20.2768 3.26646 19.8556 3.18606 19.4564C3.10854 19.0714 3.07956 18.6577 3.05322 18.2815L3.0516 18.2584L2.40161 8.18835C2.37493 7.775 2.68839 7.41828 3.10174 7.3916C3.51509 7.36492 3.87181 7.67838 3.89849 8.09173L4.54822 18.1576C4.54827 18.1583 4.54831 18.159 4.54836 18.1597C4.57658 18.5624 4.60047 18.8818 4.65654 19.1602C4.71115 19.4314 4.78695 19.6095 4.88485 19.7369C5.05368 19.9567 5.47061 20.25 6.79005 20.25H13.2101C14.5295 20.25 14.9464 19.9567 15.1153 19.7369C15.2131 19.6095 15.289 19.4314 15.3436 19.1602C15.3996 18.8818 15.4235 18.5624 15.4517 18.1597C15.4518 18.159 15.4518 18.1583 15.4519 18.1576L16.1016 8.09173C16.1283 7.67838 16.485 7.36492 16.8984 7.3916Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.58008 15.5C7.58008 15.0858 7.91586 14.75 8.33008 14.75H11.6601C12.0743 14.75 12.4101 15.0858 12.4101 15.5C12.4101 15.9142 12.0743 16.25 11.6601 16.25H8.33008C7.91586 16.25 7.58008 15.9142 7.58008 15.5Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 11.5C6.75 11.0858 7.08579 10.75 7.5 10.75H12.5C12.9142 10.75 13.25 11.0858 13.25 11.5C13.25 11.9142 12.9142 12.25 12.5 12.25H7.5C7.08579 12.25 6.75 11.9142 6.75 11.5Z"
        fill="black"
      />
    </svg>
  </button>
);

TrashCanIcon.defaultProps = {
  className: '',
};
